<div class="flex items-center w-full justify-between h-[5rem] bg-white border-bottom dark:bg-transparent overflow-x-auto overflow-y-hidden">
    <img class="max-h-[4rem] h-auto my-auto w-[200px]"
    [ngClass]="customerLogo === 'assets/images/logo/logo.png' ? 'object-cover ml-[20px]' : 'object-contain pl-[50px]'" src={{customerLogo}} alt="Customer logo">
    <div class="flex items-center pr-[15px]">
        <user></user>
        <app-languages class=""></app-languages>
    </div>
</div>